import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "@/api/client";
import type { CreateBusinessRequest, CreateBusinessResponse } from "@/api/types";

export function useCreateBusiness() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: CreateBusinessRequest) =>
      api.post("businesses", { json: data }).json<CreateBusinessResponse>(),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ["onboarding-status"] });
    },
  });
}
